import React from "react";
import { useStore } from "effector-react";
import { $userGroups } from "../../models/userModel/stores";
import EmployeeUserList from "../../components/EmployeeUserList/EmployeeUserList";
import CLIENT_CONFIG from "./clientConfigs";
import { Spin, Result } from "antd";

const EmployeeUserListPage = () => {
  const userGroups = useStore($userGroups);

  if (!userGroups || userGroups.length === 0) {
    return (
      <div style={{ marginTop: "80px", textAlign: "center" }}>
        <Spin size="large" tip="Определение доступа..." />
      </div>
    );
  }

  const currentClient = userGroups.find((group) => CLIENT_CONFIG[group]);

  if (!currentClient) {
    return (
      <Result
        status="403"
        title="Нет доступа"
        subTitle="Вы не принадлежите ни к одной из доступных организаций"
      />
    );
  }

  const { renderCardBody, renderTableColumns } = CLIENT_CONFIG[currentClient];

  return (
    <EmployeeUserList
      userGroups={userGroups}
      renderCardBody={renderCardBody}
      renderTableColumns={renderTableColumns}
    />
  );
};

export default EmployeeUserListPage;
